// Colores de los elementos de cupón; mismos valores que el cupón de recompra (DpRepurchaseCoupon).
export const COUPON_COLORS = {
	surface: '#F4F9FF',
	border: '#E0EFFF',
	borderStrong: '#C7DDF7',
	text: 'var(--color-text-primary)',
	textSecondary: '#6B6B6B',
};
